import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EverydaySpendState } from '../reducers/everyday-spend.reducer';

export const getEverydaySpendState =
  createFeatureSelector<EverydaySpendState>('everydaySpend');

export const getFormData = createSelector(
  getEverydaySpendState,
  (state) => state.formData,
);

export const getPointsTransfer = createSelector(
  getEverydaySpendState,
  (state) => state.pointsTransfer,
);

export const getCheckoutFormDataById = (loyaltyProgramId: string) =>
  createSelector(getFormData, (formData) => formData[loyaltyProgramId]);

export const getCheckoutPointsTransferLoading = createSelector(
  getPointsTransfer,
  (pointsTransfer) => pointsTransfer.loading,
);

export const getCheckoutPointsTransferError = createSelector(
  getPointsTransfer,
  (pointsTransfer) => pointsTransfer.error,
);
